// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"e80f5963","455":"701110d8","788":"fb7eb386","882":"2ca79c2c"}[chunkId] + ".chunk.css";
};